import { render, staticRenderFns } from "./ChatAnswerStatusChart.vue?vue&type=template&id=00c1d8fa"
import script from "./ChatAnswerStatusChart.vue?vue&type=script&lang=js"
export * from "./ChatAnswerStatusChart.vue?vue&type=script&lang=js"
import style0 from "./ChatAnswerStatusChart.vue?vue&type=style&index=0&id=00c1d8fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports